export default __webpack_public_path__ + "static/media/Listings Icon.814c4312.svg";